import { render, staticRenderFns } from "./producto_admin.vue?vue&type=template&id=08d2f580&"
import script from "./producto_admin.vue?vue&type=script&lang=js&"
export * from "./producto_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports